import { constants } from "./constants";
import MapTemplate from "../../template";

export default function LucaMap() {
    return <MapTemplate constants={constants} />;
}
